import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider, App as AntdApp } from 'antd'
import { store } from './store'
import App from './App.tsx'
import './index.css'

// Ant Design theme configuration with brand colors
const theme = {
  token: {
    colorPrimary: '#0171BF', // Brand blue
    colorSuccess: '#22c55e',
    colorWarning: '#F7941F', // Brand orange
    colorError: '#ef4444',
    colorInfo: '#0171BF', // Brand blue
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorTextBase: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f3f4f6',
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusXL: 20,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
    fontSize: 15,
    fontSizeLG: 16,
    fontSizeXL: 18,
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    lineHeight: 1.6,
    lineHeightLG: 1.8,
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    boxShadowTertiary: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      headerPadding: '0 24px',
      siderBg: '#0171BF',
      bodyBg: '#f8fafc',
    },
    Menu: {
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemMarginBlock: 4,
    },
    Card: {
      borderRadius: 16,
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      headerBg: '#ffffff',
      bodyPadding: 24,
    },
    Button: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
      fontWeight: 500,
      primaryColor: '#ffffff',
      primaryShadow: '0 2px 0 rgba(1, 113, 191, 0.1)',
    },
    Form: {
      labelFontSize: 15,
      verticalLabelPadding: '0 0 6px',
    },
    Input: {
      controlHeight: 44,
      controlHeightLG: 48,
      paddingBlock: 10,
      paddingInline: 14,
      borderRadius: 10,
    },
    InputNumber: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    Select: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    DatePicker: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    TimePicker: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    Cascader: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    TreeSelect: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    Mentions: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    AutoComplete: {
      borderRadius: 10,
      controlHeight: 44,
      controlHeightLG: 48,
      controlHeightSM: 36,
    },
    Typography: {
      titleMarginBottom: '0.5em',
      titleMarginTop: '1.2em',
    },
    Table: {
      borderRadius: 12,
      headerBg: '#f8fafc',
      headerColor: '#374151',
      rowHoverBg: '#f8fafc',
    },
    Statistic: {
      titleFontSize: 14,
      contentFontSize: 24,
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <AntdApp>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AntdApp>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>,
)
